import styled, { css } from "styled-components";


export const Input = styled.input<{ hasError?: boolean }>`
  padding: 12px 16px;
  width: 100%;
  /*
    Ровно 16 настоящих пикселей, мимо шкалы и мимо --ui-scale.
    Safari на iOS приближает страницу при фокусе в поле, где текст
    мельче 16px, и обратно уже не отдаляет. Через rem здесь вышло бы
    12.8px — и форма прыгала бы на каждом касании.
  */
  font-size: 16px;
  border-radius: 10px;
  border: 1px solid rgba(31, 10, 53, 0.1);
  background: rgb(247, 248, 248);
  scrollbar-width: none;

  ${({ hasError }) =>
    hasError &&
    css`
      border: 1px solid rgb(242, 40, 98);
      background: rgba(114, 82, 220, 0.15);
    `}

  &:focus {
    border: 1px solid rgb(114, 82, 220);
    background: rgba(114, 82, 220, 0.15);
  }
`;